import {useSnackbar} from 'notistack'
import {useState} from 'react'
import api from 'src/services/api'
import {LicensePlateHasList} from 'src/services/api/endpoints/LprEndpoint'
import {Page} from 'src/types'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

type PlateListItemsProps = {
  listId: number
  page: Page
}

function usePlateListItems(props: PlateListItemsProps) {
  const {listId, page} = props
  const {enqueueSnackbar} = useSnackbar()

  const [listItems, setListItems] = useState<LicensePlateHasList[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [totalItems, setTotalItems] = useState(0)

  async function getListItems() {
    setIsLoading(true)
    try {
      const res = await api.lpr.getPlates(String(listId), {page: page.page, pageSize: page.pageSize})
      setListItems(res.data.data.entities)
      setTotalItems(res.data.data.totalPages ?? 0)
    } catch (err) {
      handleErrorWithSnackbar(enqueueSnackbar, err, 'Não foi possível carregar listas de placas cadastradas')
    } finally {
      setIsLoading(false)
    }
  }

  return {listItems, isLoading, totalItems, refresh: getListItems}
}

export default usePlateListItems
